'use strict';

module.exports = function ValidationFailure(failureMessages) {
  this.isValid = false;
  this.failureMessages = failureMessages.constructor !== Array ? [failureMessages] : failureMessages;
};